import React from "react";
import { ContactForm, Location } from "../components";

function Contact() {
  return (
    <>
      <div id="contactPage">
        <ContactForm />
        <Location />
      </div>
    </>
  );
}

export default Contact;
